{
    "CAIS-LTID-Quick-Search-Fields": [
        {
            "label": "Report Date", "columnname": "reportDate", "placeholder": "Report Date",
            "width": "", "datatype": "DateRange", "isLarge": false, "fieldtype": "maskfield", "mask": "9999-99-99", "slotchar": "yyyy-mm-dd"
        },
        {
            "label": "Account Number", "columnname": "accountNumber", "placeholder": "Account Number",
            "width": "", "datatype": "String", "isLarge": true, "isXLarge": false
        },
        {
            "label": "Received FDID", "columnname": "receivedFDID", "placeholder": "Received FDID",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true
        },
        {
            "label": "Large TraderID", "columnname": "largeTraderID", "placeholder": "Large TraderID",
            "width": "", "datatype": "String", "isLarge": true, "isXLarge": false
        }
    ],
    "CAISLTIDCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 5
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 3
        },
        {
            "display": "false",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "false",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "Account Number",
            "db_columnname": "accountNumber",
            "datatype": "String",
            "mappingkey": "accountNumber",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isMultiDisabled": "true",
            "isLargeFields": true,
            "hasAlternativeField": true,
            "alternativeFields": ["receivedFDID"],
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "Received FDID",
            "db_columnname": "receivedFDID",
            "datatype": "String",
            "mappingkey": "receivedFDID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isMultiDisabled": "true",
            "isLargeFields": true,
            "hasAlternativeField": true,
            "alternativeFields": ["accountNumber"],
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "LTID Action",
            "db_columnname": "action",
            "datatype": "String",
            "mappingkey": "action",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "ADD",
                    "value": "ADD"
                },
                {
                    "label": "UPDATE",
                    "value": "UPDATE"
                },
                {
                    "label": "REPLACE",
                    "value": "REPLACE"
                },
                {
                    "label": "DELETE",
                    "value": "DELETE"
                }
            ],
            "isrequired": true,
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "Large TraderID",
            "db_columnname": "largeTraderID",
            "datatype": "String",
            "mappingkey": "largeTraderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "LTID – 00000000-0000 | ULTID – ULTXXXXX-XXXX",
            "isrequired": false,
            "regexpressions": ["^(\\d{8})([-])(\\d{4})$", "^(ULT)(\\d{5})([-])(\\d{4})$"],
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "Effective Date",
            "db_columnname": "ltidEffectiveDate",
            "datatype": "Date",
            "mappingkey": "ltidEffectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": false,
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "End Date",
            "db_columnname": "ltidEndDate",
            "datatype": "Date",
            "mappingkey": "ltidEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "End Reason",
            "db_columnname": "ltidEndReason",
            "datatype": "String",
            "mappingkey": "ltidEndReason",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "CORRECTION",
                    "value": "CORRECTION"
                },
                {
                    "label": "ENDED",
                    "value": "ENDED"
                },
                {
                    "label": "REPLACED",
                    "value": "REPLACED"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "TRANSFER",
                    "value": "TRANSFER"
                }
            ],
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Created User",
            "db_columnname": "createdUser",
            "datatype": "String",
            "mappingkey": "createdUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedUser",
            "datatype": "String",
            "mappingkey": "updatedUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 17
        }
    ]
}